import { RootState } from '../../../app/reducer';

export const selectBearerToken = ({ bearerTokenReducer }: RootState): string =>
  bearerTokenReducer.bearerToken;
